// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"5":"9bb4b9c9","211":"315de1e9","260":"75146d92"}[chunkId] + ".css";
};